module.exports = __webpack_public_path__ + "74364a81581c857bef361e28249bb4e5.svg";